module.exports = {
        srcSet: __webpack_public_path__ + "destination_host_kfc-180-237cc1a3f0d7285a.digested.png"+" 180w",
        images: [{path: __webpack_public_path__ + "destination_host_kfc-180-237cc1a3f0d7285a.digested.png",width: 180,height: 180}],
        src: __webpack_public_path__ + "destination_host_kfc-180-237cc1a3f0d7285a.digested.png",
        toString: function(){return __webpack_public_path__ + "destination_host_kfc-180-237cc1a3f0d7285a.digested.png"},
        
        width: 180,
        height: 180
      }